import { Component, EventEmitter, Input, Output } from '@angular/core';

// Shared color field (opens the brand-swatch picker). Two-way friendly: [value] + (valueChange).
@Component({
  selector: 'omp-color-input',
  templateUrl: './omp-color-input.component.html',
  styleUrls: ['./omp-controls.scss'],
})
export class OmpColorInputComponent {
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();
}
